var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 84,
    viewBox: "0 0 343 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.9258,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.9258,
    cy: 27.625,
    r: 1.00001,
    fill: "#FCFCFD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.9258,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.9258,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.9258,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.9258,
    cy: 27.625,
    r: 1.00001,
    fill: "#5834A8"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter6_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.9258,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter7_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86.9258,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.9258,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter9_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.926,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter10_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.9258,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter11_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.9258,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter12_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.9258,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter13_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.9258,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.9258,
    cy: 41.625,
    r: 1.00001,
    fill: "#372069"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter15_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.9258,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter16_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.9258,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter17_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.9258,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86.9258,
    cy: 41.625,
    r: 1.00001,
    fill: "#FCFCFD"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter19_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.9258,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter20_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.9258,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.9258,
    cy: 55.625,
    r: 1.00001,
    fill: "#5834A8"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter22_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.9258,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter23_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.9258,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter24_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.9258,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter25_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.9258,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.9258,
    cy: 55.625,
    r: 1.00001,
    fill: "#6F41D2",
    fillOpacity: 0.25,
    shapeRendering: "crispEdges"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter27_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86.9258,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter28_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.9258,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter29_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.926,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10069_16055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.198 15.112C164.742 14.0897 164.949 13.1607 164.949 13.1607C165.09 12.5315 165.443 11.8506 166.15 10.4885C167.836 7.24058 170.751 4.35464 174.076 2.80275C175.448 2.1623 178.364 1.05097 182.092 1.42154C183.269 1.5387 185.679 1.80596 188.246 3.43309C189.017 3.92194 191.11 5.36116 192.659 8.08652C193.257 9.13759 194.908 12.1426 194.341 16.0724C193.904 19.095 192.381 21.0957 191.638 22.0468C189.823 24.3717 187.73 25.5036 186.294 26.2799C185.663 26.6213 182.442 27.8464 181.571 28.1211C181.571 28.1211 181.438 28.1631 181.261 28.2413C180.837 28.4281 180.213 28.799 180.27 29.0217C180.293 29.1104 180.417 29.1498 180.49 29.1718C181.746 29.5495 182.571 29.542 182.571 29.542C183.136 29.5349 183.418 29.5312 183.922 29.4619C184.415 29.3946 185.575 29.2025 187.685 28.3412C188.639 27.952 188.575 27.9205 190.507 27.0802C191.121 26.8133 191.786 26.5243 192.249 26.3398C193.064 26.0145 194.68 25.4141 196.832 25.1588C197.689 25.057 198.642 24.9504 199.904 25.099C201.248 25.2573 202.218 25.6196 202.426 25.6994C203.064 25.9434 204.642 26.5678 206.029 28.111C206.446 28.5752 207.072 29.2856 207.49 30.3928C207.937 31.579 207.985 32.7963 207.99 32.9449C207.999 33.2256 208.004 33.8522 208.09 34.7363C208.128 35.12 208.148 35.3162 208.2 35.5269C208.293 35.9005 208.467 36.5952 209.071 37.0979C209.639 37.571 210.286 37.6212 210.552 37.6384C211.511 37.6998 212.207 37.2465 212.473 37.0679C212.759 36.8767 213.472 36.3347 213.794 35.3465C214.026 34.6375 213.944 34.042 213.894 33.7051C213.756 32.7727 213.326 32.1412 213.083 31.7935C212.486 30.9363 211.758 30.4561 211.452 30.2723C210.844 29.9066 210.347 29.779 210.372 29.682C210.399 29.5709 211.079 29.6225 211.612 29.7221C212.053 29.8044 213.194 30.0683 214.414 30.9929C214.906 31.3653 216.373 32.5099 217.016 34.6255C217.432 35.9918 217.313 37.1376 217.246 37.5976C216.963 39.5403 215.911 40.7811 215.485 41.2703C214.276 42.6583 212.904 43.2186 212.313 43.4518C211.153 43.91 210.203 43.9863 209.971 44.002C209.634 44.0252 208.557 44.0762 207.239 43.6816C205.175 43.0633 203.396 41.6109 202.264 39.7903C201.348 38.3181 201.028 35.4397 198.848 35.3278C196.718 35.2185 194.746 36.3328 193.168 37.6642C192.191 38.4884 191.351 39.4422 190.52 40.4102C190.398 40.5524 190.271 40.7103 190.263 40.8979C190.252 41.1666 190.603 41.4129 190.785 41.5563C191.806 42.3581 192.899 43.0472 193.887 43.8991C197.113 46.6814 199.568 50.2598 203.514 52.1452C205.701 53.1903 208.269 53.718 210.576 52.7355C213.093 51.6631 214.317 49.3435 214.995 46.8243C215.44 45.1676 215.544 43.862 215.655 43.8722C215.692 43.8755 215.696 44.017 215.746 44.4426C215.816 45.0617 215.83 44.9723 215.926 45.7235C216.037 46.5956 216.108 47.4135 216.126 47.6549C216.312 50.2265 215.536 52.3383 215.536 52.3383C215.349 52.8451 214.615 54.7066 212.773 56.3513C210.841 58.0765 208.795 58.5762 207.469 58.8831C204.798 59.5015 202.654 59.1628 201.585 58.9831C201.585 58.9831 199.519 58.6357 196.972 57.472C196.129 57.0868 195.249 56.507 195.19 56.4411C195.186 56.4363 195.145 56.388 195.13 56.3962C195.121 56.4011 195.125 56.4247 195.127 56.4314C195.154 56.5927 195.121 56.7612 195.153 56.9218C195.215 57.2358 195.187 58.553 195.149 59.3297C195.131 59.7078 195.1 60.3134 195.006 61.056C194.93 61.6568 194.771 62.8699 194.286 64.3511C194.031 65.1304 193.665 66.223 192.867 67.496C191.971 68.9267 190.995 69.8426 190.548 70.2356C189.97 70.7432 188.807 71.7463 186.983 72.4122C186.271 72.672 185.137 73.0737 183.605 73.0276C183.101 73.0126 182.005 72.9325 180.731 72.4122C179.386 71.8635 178.522 71.101 178.179 70.7761C177.762 70.3816 176.867 69.5143 176.302 68.0665C176.115 67.587 175.793 66.7343 175.829 65.5897C175.838 65.3228 175.901 63.9524 176.82 62.5349C178.001 60.7139 179.754 60.1105 180.258 59.9454C180.6 59.8332 181.144 59.6602 181.879 59.6602C183.1 59.6606 184.138 60.1386 184.123 60.2007C184.118 60.2206 184.005 60.2045 183.888 60.1951C183.062 60.1277 182.363 60.4103 182.064 60.5309C181.714 60.6724 180.907 61.0111 180.3 61.8593C180.158 62.0592 179.365 63.1683 179.678 64.5764C179.711 64.725 179.889 65.4766 180.548 66.1452C180.664 66.2627 181.409 66.996 182.575 67.121C182.797 67.1449 183.134 67.1779 183.551 67.0686C184.281 66.8766 184.713 66.3888 184.909 66.1605C185.121 65.9146 185.514 65.3823 185.727 64.2616C185.782 63.9738 186.016 62.6401 185.51 60.6813C185.371 60.145 184.939 58.6451 183.813 57.0262C182.196 54.7006 180.339 53.8442 180.199 53.6989C180.192 53.6922 180.158 53.6544 180.131 53.6634C180.11 53.6705 180.104 53.7034 180.102 53.7109C180.045 53.9643 179.861 54.1743 179.784 54.4221C179.704 54.6796 179.492 55.006 179.067 55.6588C178.822 56.0361 178.485 56.5497 177.979 57.1598C177.352 57.9144 176.86 58.3378 176.23 58.9161C175.013 60.0327 174.223 60.7581 173.445 61.7006C172.961 62.2879 172.152 63.2828 171.484 64.7628C171.328 65.1083 170.66 66.6325 170.443 68.7859C170.195 71.2493 170.667 73.2432 171.024 74.3703C171.682 76.4541 172.684 77.918 173.285 78.6936C173.878 79.4579 174.764 80.5812 176.267 81.5357C177.877 82.5576 179.7 83.073 179.65 83.2246C179.641 83.2523 179.575 83.2515 179.373 83.2407C178.219 83.1785 177.576 83.0719 177.576 83.0719C176.998 82.9757 176.709 82.9278 176.401 82.8604C176.027 82.7784 174.793 82.4909 173.287 81.7947C172.972 81.6491 171.764 81.0779 170.33 80.0235C168.596 78.7482 167.514 77.4879 167.26 77.1862C165.048 74.5604 164.272 71.804 163.96 70.6515C163.182 67.776 163.081 64.8175 163.738 61.9136C164.265 59.5854 165.255 57.3949 166.393 55.3066C166.975 54.2398 167.603 53.2011 168.225 52.1579C168.498 51.6994 168.674 51.2622 168.838 50.752C168.901 50.5547 169.162 49.0047 169.262 48.9695C168.58 49.2113 167.899 49.4397 167.236 49.7297C165.394 50.5326 164.473 50.9343 163.873 51.2382C162.928 51.7177 160.969 52.7239 158.715 54.4457C157.686 55.231 156.534 56.1117 155.232 57.5528C153.344 59.6441 152.334 61.5962 151.794 62.6566C151.187 63.8506 150.685 64.8377 150.308 66.3042C149.675 68.7702 149.868 70.7552 149.933 71.3181C150.018 72.0563 150.292 73.8788 151.344 75.9267C151.765 76.7445 152.493 78.1632 153.926 79.4542C154.319 79.8079 155.467 80.7856 155.427 80.8354C155.425 80.8384 155.419 80.8372 155.247 80.783C155.084 80.7309 155.06 80.7231 155.06 80.7231C154.808 80.6392 154.594 80.57 154.515 80.543C154.274 80.4607 153.751 80.2451 153.228 79.9801C152.013 79.3647 150.992 78.5989 150.992 78.5989C150.654 78.3454 149.37 77.3591 148.064 75.6755C147.624 75.108 146.539 73.6314 145.678 71.4499C144.624 68.7803 144.494 66.5416 144.432 65.3104C144.272 62.1209 144.871 59.7104 145.258 58.2026C145.963 55.4522 146.919 53.5417 147.727 51.9281C148.35 50.6839 149.387 48.782 150.617 47.3121C151.814 45.8796 153.232 44.812 153.251 44.7978C153.276 44.7791 153.301 44.7593 153.327 44.7417C153.381 44.705 153.396 44.6994 153.395 44.6915C153.391 44.6698 153.271 44.6825 153.105 44.6691C153.019 44.662 152.968 44.6518 152.917 44.644C152.724 44.614 152.339 44.5878 151.934 44.5789C151.759 44.5751 151.348 44.5665 150.893 44.5938C150.666 44.6073 149.808 44.6672 148.709 44.9592C147.48 45.2856 146.604 45.7291 146.357 45.8575C145.386 46.3624 144.73 46.8891 144.145 47.3649C143.792 47.6523 143.792 47.6755 142.573 48.791C141.484 49.787 140.932 50.2912 140.554 50.5922C139.723 51.2536 139.169 51.6945 138.298 52.1081C137.719 52.3832 136.684 52.8616 135.273 52.8811C134.645 52.8897 134.172 52.8043 133.9 52.7534C133.581 52.6939 132.26 52.4267 130.855 51.4901C130.183 51.0421 128.489 49.8772 127.643 47.5872C127.409 46.9542 126.869 45.2324 127.383 43.1741C127.556 42.4786 127.878 41.1898 129.044 40.1219C130.131 39.1259 131.327 38.8961 131.586 38.8511C131.586 38.8511 132.998 38.6052 134.358 39.1716C134.441 39.2064 134.687 39.3086 134.678 39.3366C134.673 39.3542 134.568 39.3351 134.548 39.3318C134.294 39.2876 133.594 39.3647 132.977 39.632C132.133 39.998 131.662 40.6261 131.445 40.923C131.202 41.2565 130.76 41.8621 130.685 42.7694C130.661 43.0573 130.61 43.8059 131.065 44.5706C131.597 45.4634 132.462 45.7796 132.831 45.8815C133.031 45.9365 133.904 46.1779 134.738 45.7714C134.924 45.6804 135.046 45.5876 135.258 45.4263C135.906 44.9333 136.289 44.4153 136.424 44.2352C136.976 43.5005 137.628 42.8462 138.22 42.1436C139.075 41.1307 139.502 40.6246 140.022 40.0269C140.503 39.4736 140.981 38.9327 141.347 38.4955C141.595 38.1998 142.08 37.6077 142.118 37.5849C142.121 37.5834 142.142 37.5718 142.148 37.5504C142.148 37.5504 142.15 37.5396 142.147 37.5276C142.136 37.4842 141.806 37.4542 141.635 37.4261C141.559 37.4138 141.558 37.4086 141.305 37.3404C140.956 37.2468 140.723 37.1929 140.622 37.1679C140.05 37.0256 139.192 36.6704 138.982 36.5824C138.073 36.2014 137.412 35.8346 137.233 35.7343C136.869 35.5299 136.124 35.0927 135.251 34.4208C134.867 34.1243 133.955 33.3952 132.947 32.2741C132.608 31.8976 132.036 31.2556 131.439 30.3453C130.421 28.7957 129.96 27.4264 129.705 26.6527C128.972 24.4286 128.871 22.6016 128.849 21.9993C128.775 19.9683 129.103 18.4512 129.427 16.948C129.71 15.6386 129.955 15.0072 130.028 14.8237C130.268 14.2189 130.808 13.0188 131.874 11.769C133.237 10.1714 134.813 9.24913 134.861 9.30715C134.876 9.32399 134.764 9.42918 134.614 9.59238C133.954 10.3099 133.61 11.0028 133.36 11.5062C133.249 11.7301 132.717 12.8268 132.467 14.4184C132.2 16.117 132.403 17.4436 132.519 18.1712C132.84 20.1685 133.54 21.5823 133.735 21.9615C134.847 24.1265 136.322 25.3808 137.083 26.0145C138.74 27.395 140.277 28.044 141.361 28.4913C141.361 28.4913 143.581 29.408 146.882 29.8568C147.182 29.8976 148.195 30.196 148.239 29.8003C148.28 29.4309 147.735 28.8084 147.584 28.4779C147.416 28.1088 147.237 27.7405 147.091 27.3617C146.382 25.5219 146.036 23.5613 145.963 21.595C145.926 20.5997 145.958 19.6022 146.041 18.6099C146.114 17.7243 146.306 16.8765 145.99 16.0152C145.749 15.3598 145.323 14.8578 144.593 14.759C144.03 14.6826 143.418 14.8619 142.968 15.2044C142.306 15.7079 142.113 16.4303 141.997 16.8656C141.934 17.1014 141.742 17.853 141.907 18.7469C141.976 19.1212 142.138 19.6868 142.037 19.7276C142.016 19.7362 141.989 19.7182 141.973 19.7063C141.368 19.2754 141.364 19.2706 141.343 19.2503C140.924 18.8465 140.957 18.8813 140.93 18.8525C140.84 18.7563 140.392 18.2708 140.05 17.6816C139.472 16.6841 139.321 15.5982 139.28 15.2299C139.208 14.5853 139.054 13.1944 139.81 11.7173C140.544 10.2841 141.711 9.59949 142.192 9.32549C144.294 8.12919 146.397 8.52746 147.025 8.67494C148.428 9.00433 149.353 9.70018 149.647 9.93599C150.87 10.9137 151.418 12.0958 151.739 12.7882C152.082 13.5279 152.277 14.2174 152.45 14.8297C152.601 15.3672 152.696 15.8224 152.88 16.711C153.239 18.4504 153.21 18.5968 153.47 19.6932C153.757 20.9033 153.99 21.5576 154.071 21.7796C154.231 22.2205 154.412 22.7112 154.739 23.3258C155.282 24.3488 155.847 24.9957 155.977 25.1424C156.232 25.4291 156.524 25.7551 156.99 26.1029C157.893 26.777 158.756 26.9746 159.84 27.1629C160.277 27.2389 159.861 26.6239 159.773 26.4892C158.217 24.0902 157.657 21.0141 158.597 18.2599C158.71 17.929 158.956 17.2381 159.618 16.8113C159.952 16.5954 160.282 16.5183 160.571 16.4513C161.104 16.3266 161.222 16.4149 161.997 16.3161C162.537 16.2473 162.815 16.2094 163.168 16.0459C163.695 15.8014 163.954 15.4777 164.024 15.3852C164.115 15.2654 164.171 15.1636 164.198 15.112Z",
    fill: "url(#paint0_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.189 42.2986C180.198 41.1098 180.208 39.8607 179.558 38.4709C178.958 37.1874 178.291 36.8434 177.126 34.7432C176.574 33.7464 176.294 33.2332 176.126 32.5014C176.021 32.0485 175.599 30.217 176.526 28.6786C176.763 28.284 177.048 27.9782 177.606 27.3775C178.454 26.4664 178.61 26.5233 178.988 25.9764C179.647 25.0197 179.854 23.7841 179.424 22.6896C179.38 22.5777 179.327 22.4635 179.232 22.389C179.193 22.3587 179.13 22.3389 179.1 22.3782C179.089 22.3931 179.086 22.4126 179.084 22.4313C179.062 22.6282 179.089 22.8217 179.077 23.0179C179.045 24.006 178.742 24.9036 178.037 25.6133C177.384 26.2714 176.556 26.8051 175.724 27.2064C175.127 27.4942 174.407 27.5474 173.754 27.5092C172.472 27.4344 171.212 26.9141 170.23 26.0913C170.115 25.9944 170.002 25.8926 169.894 25.7866C169.629 25.5254 169.377 25.2372 169.17 24.9257C169.099 24.8183 168.933 24.6079 169.028 24.4964C169.266 24.5915 169.478 24.7502 169.722 24.8415C170.863 25.2686 172.166 24.7648 173.1 23.9806C174.032 23.1968 174.712 22.1588 175.541 21.2653C176.272 20.4767 177.191 19.7711 178.262 19.6667C179.29 19.5663 180.355 20.0863 180.908 20.9588C181.272 20.5223 181.178 19.8534 180.902 19.3567C180.273 18.2218 178.865 17.6742 177.572 17.7891C176.279 17.904 175.097 18.5759 174.086 19.39C173.075 20.2042 172.195 21.1684 171.205 22.0083C171.408 19.0146 172.386 16.0763 174.018 13.5586C175.928 10.6136 178.789 8.22846 182.148 7.20921C184.411 6.52235 186.81 6.46433 189.178 6.49091C189.319 6.49241 189.405 6.33707 189.33 6.21766C189.024 5.73181 188.489 5.40167 187.966 5.13665C183.668 2.95704 178.284 3.16067 174.093 5.53941C169.902 7.91816 166.989 12.3653 166.343 17.1408C166.198 18.2151 166.164 19.3335 166.517 20.3588C166.668 20.7974 166.889 21.271 166.721 21.7033C165.764 21.2859 165.161 20.3472 164.406 19.624C163.782 19.0258 162.997 18.5501 162.136 18.4782C161.275 18.406 160.342 18.8102 159.962 19.5866C161.432 19.0116 163.265 19.5858 164.144 20.8966C164.636 21.6295 164.833 22.5185 165.242 23.3005C165.652 24.0824 166.412 24.8059 167.29 24.7199C167.257 24.7232 167.086 25.0975 167.055 25.1454C166.953 25.3027 166.839 25.4516 166.714 25.5916C166.464 25.8712 166.173 26.113 165.852 26.3069C165.531 26.5012 165.196 26.5903 164.852 26.7243C164.479 26.8699 164.145 27.0395 163.73 27.0687C163.488 27.0855 163.207 27.0174 163 27.1817C162.794 27.3453 162.892 27.5736 162.938 27.79C163.266 29.337 162.623 30.7324 161.572 31.8378C160.756 32.6964 159.763 33.39 158.672 33.853C157.27 34.4478 155.778 34.784 154.29 35.0812C152.825 35.3739 151.38 35.7055 149.934 36.063C147.035 36.7805 144.422 38.2811 142.13 40.1755C141.411 40.7703 140.741 41.4235 140.125 42.1249C138.434 44.053 138.084 44.6523 136.961 45.7367C136.109 46.5605 135.119 47.3327 133.603 47.2728C133.254 47.259 131.353 47.1568 130.42 45.5914C129.614 44.239 129.854 42.5925 130.176 41.6934C130.434 40.9743 130.791 40.1272 131.686 39.6069C133.006 38.8396 134.685 39.3925 134.694 39.3337C134.7 39.2914 133.829 38.9673 132.698 39.0316C132.236 39.0578 130.815 39.151 129.636 40.2126C128.084 41.6095 128.055 43.6536 128.055 44.1754C128.055 45.9519 128.569 47.7868 129.96 49.1942C132.122 51.3813 135.044 50.8153 136.605 49.9746C138.291 49.0669 139.628 47.5262 140.503 46.4838C141.964 44.7417 141.806 44.6339 143.115 43.3613C144.938 41.5882 146.327 40.4566 147.99 39.827C148.969 39.4561 150.861 38.7543 153.364 38.536C154.703 38.4193 155.369 38.5151 156.756 38.2007C157.393 38.0566 158.664 37.7167 160.089 36.9396C160.627 36.6458 163.028 35.2867 164.952 32.3914C166.1 30.6639 166.545 29.1929 166.664 29.2389C166.791 29.2883 166.327 30.9982 165.628 32.7065C164.522 35.4076 163.162 37.2907 162.611 38.0206C161.382 39.6463 160.863 39.9217 157.477 43.1543C152.305 48.0918 151.244 49.6175 150.797 50.2898C149.354 52.46 148.595 54.3305 148.14 55.4687C147.302 57.5671 146.156 60.4336 146.069 64.3403C146.032 65.9566 145.998 68.8114 147.375 72.0859C147.745 72.967 148.824 75.3619 151.113 77.6702C153.223 79.7993 155.403 80.8912 155.444 80.8332C155.484 80.777 153.441 79.7413 151.698 77.5351C150.144 75.567 149.624 73.6015 149.086 71.8609C148.703 70.6235 147.746 67.4579 148.275 63.6197C148.854 59.4237 150.9 56.6321 152.644 54.2526C153.51 53.0698 156.266 49.3806 160.84 46.5968C161.458 46.2206 163.029 45.301 165.313 43.8299C168.13 42.016 169.034 41.2928 169.817 40.0921C170.735 38.6843 171.051 37.2877 171.167 36.5342C171.397 35.0535 171.195 33.8845 170.897 32.166C170.542 30.1163 170.065 28.8103 170.132 28.7886C170.212 28.7628 170.941 30.6284 171.618 32.7967C172.24 34.7911 172.749 36.4193 173.059 38.6963C173.403 41.2206 173.312 43.1389 173.284 43.6499C173.252 44.2233 173.142 46.0747 172.654 47.9732C171.645 51.8974 169.887 52.6726 167.775 56.9847C167.014 58.5396 166.015 60.5785 165.554 63.4094C165.308 64.9171 164.669 69.1959 166.815 73.8571C168.301 77.0867 170.403 78.9646 170.958 79.4411C174.583 82.5565 179.663 83.2355 179.667 83.2224C179.669 83.2183 178.841 83.0031 177.803 82.5835C177.012 82.2638 176.407 82.0194 175.882 81.7577C174.653 81.1465 173.822 80.4233 173.31 79.9715C172.617 79.361 170.878 77.7934 169.767 75.1077C169.114 73.5304 168.963 72.2442 168.837 71.1748C168.493 68.2634 168.943 65.9974 169.107 65.2603C169.387 63.9997 169.879 62.4863 171.629 59.4061C174.14 54.9859 174.827 55.1094 177.033 51.3C179.968 46.2304 180.179 43.544 180.189 42.2986Z",
    fill: "url(#paint1_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.523 28.8993C150.402 28.7525 150.292 28.5987 150.193 28.437C149.673 27.5903 149.232 26.6942 148.882 25.7648C148.315 24.2627 148.122 23.0402 147.981 22.1171C147.729 20.4634 147.716 18.7872 147.697 17.1186C147.685 16.0312 147.719 14.7058 147.079 13.7415C146.27 12.5224 144.421 12.3053 143.163 12.8855C141.73 13.5458 141.342 15.0786 141.271 15.3623C140.786 17.3001 142.217 19.6261 142.044 19.7032C141.889 19.7724 140.292 17.987 139.976 16.1592C139.852 15.436 139.776 13.4121 140.817 11.8756C141.921 10.2473 144.025 9.59304 145.912 9.92955C149.573 10.5823 150.886 14.5747 151.509 17.7257C152.005 20.2358 152.327 22.95 153.531 25.2415C154.112 26.3468 154.936 27.2369 156.093 27.7374C156.777 28.0335 158.305 28.111 158.564 28.9621C158.78 29.6737 158.127 30.6001 157.483 31.0336C155.33 32.4837 151.941 30.6203 150.523 28.8993Z",
    fill: "url(#paint2_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.925 11.3287C132.956 11.2947 132.988 11.2606 133.019 11.2266C131.904 13.3141 131.396 15.722 131.574 18.0824C131.887 22.2362 134.376 26.0815 137.738 28.4557C138.377 28.9071 139.05 29.3095 139.751 29.6573C141.459 30.5043 143.316 31.0471 145.209 31.2724C146.683 31.448 148.035 31.354 149.49 31.1051C149.956 31.0254 150.59 31.004 150.788 31.5348C151.235 32.7322 150.205 33.7747 149.217 34.2167C148.227 34.6592 147.111 34.8115 146.037 34.8778C143.915 35.0088 141.757 34.6094 139.793 33.8065C137.073 32.6948 134.679 30.7858 133.186 28.2353C132.845 27.6532 132.546 27.0472 132.281 26.4273C131.374 24.3069 130.681 22.0442 130.471 19.7399C130.29 17.7624 130.415 15.8059 131.223 13.9605C131.644 12.9997 132.217 12.1039 132.925 11.3287Z",
    fill: "url(#paint3_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.225 38.3355C180.792 38.6466 181.445 39.6415 181.64 40.5122C181.939 41.8462 181.945 43.3592 181.737 44.8048C181.568 45.9749 181.166 47.2389 181.315 48.4932C181.558 50.534 183.105 51.9814 184.468 53.3754C186.004 54.9456 187.455 56.3882 187.98 58.6329C188.655 61.52 188.692 66.2745 186.058 68.1479C184.331 69.3768 180.929 69.4464 179.273 67.7276C178.286 66.7031 178.032 65.1662 178.253 63.9448C179.043 59.5616 183.386 60.062 182.926 60.0418C182.733 60.0336 178.983 59.6417 177.462 63.2643C176.498 65.5607 177.209 68.5511 179.03 70.0992C180.572 71.4097 182.638 71.723 184.587 71.3902C191.561 70.1991 195.108 61.9433 193.597 55.5782C192.341 50.2877 189.34 45.5882 185.638 41.6684C185.321 41.3323 181.964 37.8048 181.225 38.3355Z",
    fill: "url(#paint4_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.406 45.5474C190.426 45.6024 190.458 45.6552 190.489 45.7053C191.734 47.7064 192.754 49.8295 193.592 52.0312C193.703 52.3209 194.349 53.7706 194.853 54.5833C195.477 55.5894 196.223 55.5868 196.624 55.8743C198.078 56.916 201.155 58.2994 205.031 57.9457C208.398 57.6384 212.533 56.1988 214.305 53.1373C214.775 52.3254 215.475 50.9094 215.661 49.8497C215.829 48.8907 215.883 45.422 215.672 43.982C215.671 43.9801 215.668 43.9798 215.668 43.982C215.374 45.4212 215.767 48.0433 213.702 51.5057C211.505 55.1896 206.904 55.2353 203.213 53.8301C201.848 53.3102 200.549 52.6046 199.364 51.7505C198.385 51.0453 197.487 50.2278 196.697 49.3159C196.052 48.5714 195.48 47.7689 194.88 46.9889C194.287 46.2167 193.724 45.4351 192.77 45.0975C192.35 44.9489 190.455 44.6943 190.388 45.4197C190.383 45.4635 190.391 45.5062 190.406 45.5474Z",
    fill: "url(#paint5_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.389 29.6789C210.93 29.6931 212.725 30.3586 213.065 30.5574C213.44 30.7767 213.792 31.0354 214.115 31.3247C214.766 31.9064 215.303 32.6135 215.698 33.3909C216.45 34.868 216.787 36.8507 216.102 38.4052C215.168 40.5257 213.095 41.9222 210.802 42.2973C208.174 42.7266 205.554 41.5206 204.112 39.2826C203.523 38.3678 203.04 37.3665 202.537 36.4041C201.993 35.3609 201.183 34.2208 200.105 33.7473C198.472 33.0293 196.007 33.3116 194.476 34.2275C193.264 34.9529 191.964 35.779 191.044 36.8503C189.82 38.2753 189.063 40.1559 186.897 39.758C186.09 39.6097 185.336 39.253 184.618 38.857C182.738 37.8217 181.022 36.4846 179.617 34.8586C178.786 33.8974 178.104 32.786 177.778 31.5583C177.484 30.4496 178.741 30.5334 179.47 30.6244C181.749 30.9096 184.028 30.9905 186.261 30.3725C188.4 29.7807 190.374 28.7405 192.434 27.9365C195.45 26.7589 199.026 25.8692 202.098 27.3656C203.991 28.288 205.426 30.0824 205.959 32.1201C206.253 33.2435 206.286 34.4192 206.529 35.5545C206.772 36.6897 207.281 37.8441 208.256 38.4745C209.187 39.0763 210.397 39.0954 211.467 38.8046C212.594 38.4984 213.661 37.8366 214.253 36.8309C214.919 35.6997 214.964 34.348 214.349 33.1892C213.92 32.3788 213.659 30.7876 210.389 29.6789Z",
    fill: "url(#paint6_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.62 9.05339C191.655 9.01296 191.711 8.99724 191.796 9.02756C191.936 9.07772 192.043 9.2368 192.124 9.35246C192.353 9.68148 192.522 10.0547 192.681 10.4215C192.712 10.4934 192.742 10.5656 192.772 10.6375C193.119 11.4494 193.344 12.3095 193.457 13.1847C193.714 15.182 193.214 17.1793 192.16 18.8948C191.286 20.3187 190.724 21.0145 189.472 22.1015C189.282 22.2673 188.278 23.1368 187.988 23.0882C187.598 23.0231 187.678 21.966 187.657 21.6793C187.568 20.4815 187.153 19.3196 186.237 18.5062C185.923 18.2277 185.528 17.8329 186.011 17.4731C186.307 17.2534 186.689 17.2257 187.033 17.1314C188.849 16.6347 190.434 15.3661 191.317 13.7035C191.591 13.1891 191.808 12.6389 191.904 12.0625C192.057 11.1469 191.834 10.2291 191.594 9.34947C191.565 9.24616 191.565 9.11814 191.62 9.05339Z",
    fill: "#6222DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.969 22.5027C176.002 22.4563 176.038 22.411 176.076 22.3672C176.765 21.5718 178.462 21.5359 178.538 22.8504C178.56 23.2296 178.433 23.6125 178.293 23.9603C177.963 24.7819 177.267 25.3763 176.483 25.7502C175.819 26.0665 175.075 26.1882 174.344 26.1635C173.975 26.1511 173.608 26.1017 173.248 26.0186C173.118 25.9887 172.358 25.8524 172.363 25.675C172.365 25.614 172.489 25.5702 172.568 25.5451C173.072 25.3853 173.618 25.4115 174.098 25.1734C174.821 24.8152 175.165 24.1149 175.499 23.4205C175.65 23.1076 175.768 22.7853 175.969 22.5027Z",
    fill: "#E3DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.142 25.3245C164.169 25.0647 163.719 24.8891 163.35 24.6118C162.885 24.2622 162.651 23.8268 162.38 23.3234C162.098 22.8012 162.003 22.3977 161.877 22.4146C161.854 22.4176 161.793 22.4404 161.733 22.7481C161.678 23.0281 161.598 23.4346 161.761 23.9646C161.82 24.1574 162.106 25.0905 162.958 25.4229C163.336 25.57 163.956 25.6509 164.108 25.4229C164.136 25.3806 164.14 25.3398 164.142 25.3245Z",
    fill: "#E3DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.305 12.8724C140.751 11.7161 141.537 10.7905 142.732 10.2852C143.825 9.82251 144.981 9.71284 146.142 9.96213C148.309 10.4278 149.665 12.2413 150.475 14.1529C151.286 16.0668 151.57 18.0495 151.969 20.1434C152.354 22.1617 152.851 24.3368 154.01 26.0276C153.709 25.6177 153.389 25.1962 153.127 24.7474C152.874 24.3121 152.637 23.867 152.437 23.4048C152.031 22.4671 151.744 21.4827 151.514 20.4893C151.118 18.7798 150.865 17.0347 150.349 15.3578C149.855 13.7532 149.069 12.1571 147.709 11.1726C146.545 10.3301 145.013 10.0179 143.612 10.3376C142.211 10.6568 140.987 11.6083 140.305 12.8724Z",
    fill: "url(#paint7_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.567 16.3184C131.583 16.1485 131.452 18.2147 131.853 19.9122C132.52 22.7345 133.848 24.5346 134.56 25.4434C135.062 26.0838 136.551 27.8764 139.085 29.307C139.085 29.307 141.302 30.5587 143.942 31.0738C144.681 31.2179 145.276 31.2781 145.276 31.2781C145.696 31.3204 146.058 31.3459 145.982 31.3414C145.957 31.3399 144.824 31.3848 144.018 31.3504C143.437 31.3257 141.443 31.085 139.44 30.2559C136.611 29.0847 134.921 27.0237 133.951 25.6463C133.178 24.5492 131.893 22.6798 131.529 20.0222C131.297 18.3217 131.561 16.3836 131.567 16.3184Z",
    fill: "url(#paint8_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.477 30.8097C181.722 30.7771 183.715 31.0504 186.423 30.3152C187.033 30.1498 187.661 29.9503 189.048 29.3551C191.225 28.4208 191.378 28.3254 192.694 27.7976C194.113 27.2286 195.595 26.8079 197.511 26.6092C198.343 26.5227 199.818 26.5066 201.331 27.013C201.914 27.2081 202.59 27.585 203.225 28.0488C203.557 28.2921 203.826 28.5601 203.915 28.6405C204.178 28.8786 204.462 29.2383 204.418 29.1833C204.385 29.1414 203.747 28.5537 202.549 27.8769C201.521 27.2956 200.611 27.0718 200.267 26.9962C198.962 26.7098 197.922 26.8337 197.125 26.9363C196.457 27.022 195.471 27.2051 193.723 27.8769C191.439 28.7547 191.458 29.0822 189.46 29.8986C188.111 30.4496 186.423 31.1211 184.216 31.1597C182.697 31.1859 181.383 30.822 181.477 30.8097Z",
    fill: "url(#paint9_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.844 44.1523C189.617 46.3428 190.775 48.3454 191.514 49.8198C192.555 51.8953 193.071 53.5285 193.243 54.1053C193.453 54.8094 193.65 55.4599 193.796 56.3354C193.919 57.0754 194.167 58.9462 193.737 61.2846C193.542 62.3412 193.033 64.5171 191.446 66.8704C189.913 69.1425 187.904 70.1984 187.906 70.201C187.907 70.2025 188.534 69.7436 189.277 68.977C190.382 67.838 191.325 66.4736 191.848 64.9506C192.442 63.2212 192.632 61.2774 192.58 59.4699C192.489 56.3261 191.685 53.2477 190.622 50.2903C190.458 49.8314 190.279 49.3777 190.087 48.9297C189.745 48.1358 189.385 47.3501 189.057 46.5502C188.626 45.4995 188.167 44.6827 187.844 44.1523Z",
    fill: "url(#paint10_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.056 44.174C128.054 44.5004 128.071 44.9133 128.14 45.3861C128.218 45.9273 128.332 46.3267 128.361 46.4274C128.457 46.7557 128.685 47.5181 129.255 48.3394C129.512 48.7088 129.998 49.3945 130.896 49.9482C131.089 50.0672 132.016 50.6627 133.335 50.7114C134.745 50.7634 135.792 50.3711 136.302 50.1413C136.983 49.834 137.427 49.4806 137.943 49.0827C138.897 48.3476 139.534 47.6154 140.374 46.6374C140.966 45.9475 141.496 45.2131 142.073 44.5113C142.807 43.6178 143.629 42.8392 144.51 42.0906C145.512 41.2402 146.587 40.4092 147.8 39.9046C149.32 39.2728 151.336 38.8663 153.074 38.5609C150.232 38.3329 147.154 39.055 144.728 40.5533C144.121 40.9276 143.548 41.3543 143.021 41.8342C142.597 42.2209 142.203 42.642 141.849 43.0949C140.978 44.2103 140.267 45.4414 139.376 46.5419C139.065 46.9256 138.733 47.2924 138.369 47.6267C136.402 49.4342 133.552 50.5508 131.059 49.1307C130.165 48.6216 129.396 47.8707 128.902 46.966C128.355 45.9681 128.031 44.8156 128.056 44.174Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.908 31.4877C154.495 31.433 153.869 31.2451 153.279 30.9655C153.114 30.8873 152.792 30.7462 152.35 30.4823C151.076 29.7221 150.317 28.6639 150.18 28.4457C149.907 28.0118 149.728 27.6974 149.467 27.1902C148.743 25.7881 148.427 24.4828 148.249 23.741C147.787 21.8155 147.737 19.1833 147.734 19.1328C147.782 19.9211 148.053 22.1063 148.261 22.8621C148.985 25.4968 149.649 27.5997 151.722 29.496C152.176 29.9107 152.908 30.4988 153.424 30.8327C153.819 31.0883 154.441 31.3881 154.908 31.4877Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.986 39.0229C184.931 38.7193 186.456 38.4202 187.847 37.684C188.834 37.1618 189.491 36.3679 190.289 35.6163C191.296 34.6685 192.424 33.808 193.658 33.1754C194.924 32.5263 196.331 32.0262 197.772 31.9465C198.781 31.8907 199.92 32.003 200.806 32.5297C201.612 33.0081 202.215 33.7649 202.641 34.5873C203.355 35.9617 204.118 37.3239 204.949 38.6317C206.151 40.5231 208.285 42.0035 210.614 41.7823C211.927 41.658 212.904 41.3559 213.286 41.2017C214.218 40.8263 214.83 40.2285 215.096 39.9785C215.189 39.8916 214.268 40.9154 213.159 41.5027C212.005 42.1147 210.985 42.2708 210.764 42.3018C210.149 42.389 208.515 42.614 206.742 41.7138C206.077 41.3765 205.542 40.9296 205.311 40.7264C204.961 40.4187 204.682 40.2783 203.795 38.7515C203.492 38.229 203.192 37.7053 202.926 37.1625C202.589 36.4734 202.219 35.7974 201.75 35.1873C201.557 34.9358 201.365 34.6868 201.133 34.4701C200.849 34.2047 200.529 33.9805 200.179 33.811C199.487 33.476 198.726 33.3835 198.152 33.3633C197.854 33.3528 196.92 33.2779 195.647 33.7035C194.97 33.93 194.538 34.1928 193.801 34.6374C193.012 35.1139 192.36 35.5597 191.539 36.3282C190.925 36.9028 190.311 37.7906 190.275 37.8389C189.926 38.3057 189.78 38.549 189.411 38.8986C189.074 39.219 188.737 39.5316 188.203 39.6989C187.666 39.8669 187.249 39.807 186.938 39.7625C186.732 39.7329 186.25 39.6416 185.435 39.2722C185.078 39.1101 184.996 39.0768 184.986 39.0229Z",
    fill: "url(#paint11_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.664 83.2236C179.641 83.2853 175.666 82.2459 172.775 79.4864C172.211 78.9482 171.8 78.4515 171.685 78.31C170.23 76.5256 169.612 74.7915 169.376 74.0294C169.083 73.0782 168.986 72.3558 168.886 71.6147C168.745 70.5573 168.503 68.6389 168.921 66.2299C169.282 64.1491 169.975 62.6301 170.411 61.6917C170.767 60.924 171.098 60.3386 171.546 59.548C171.946 58.8406 172.64 57.6596 173.626 56.2253C174.699 54.6629 174.768 54.764 175.663 53.4741C177.1 51.4008 177.956 49.6464 178.241 49.0449C178.879 47.6958 179.496 46.3356 179.838 44.8769C180.09 43.797 180.157 42.999 180.181 42.5775C180.234 41.6567 180.289 40.6951 179.94 39.5228C179.889 39.3528 179.643 38.4268 179.014 37.5363C178.623 36.9838 178.545 36.8951 178.035 36.1547C177.38 35.2021 177.183 34.8581 177.186 34.8633C177.571 35.6872 178.685 37.3821 179.042 38.149C180.158 40.5446 180.089 42.2361 179.449 44.8092C177.859 51.2001 171.781 55.4853 169.12 61.4488C169.093 61.5105 169.066 61.5723 169.039 61.6344C168.511 62.8487 168.105 64.1154 167.864 65.4183C167.256 68.7074 167.465 72.2372 168.797 75.3308C169.729 77.4966 171.232 79.3891 173.205 80.6951C175.175 81.9999 177.314 82.64 179.576 83.197C179.581 83.1974 179.667 83.2146 179.664 83.2236Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.122 48.6564C192.168 48.6343 193.016 51.0269 195.129 53.488C195.694 54.1464 196.147 54.6735 196.87 55.2293C199.111 56.9511 201.536 57.3857 203.14 57.5111C204.522 57.6189 206.863 57.6425 209.351 56.6378C212.398 55.4082 214.05 53.5359 214.231 53.2526C214.301 53.1429 213.667 54.2119 213.024 54.773C212.483 55.2461 211.962 55.6545 211.147 56.1168C209.297 57.1671 207.453 57.5766 206.526 57.7391C205.477 57.9228 203.858 58.2111 201.404 57.7907C199.025 57.3831 197.414 56.4544 197.243 56.3167C197.221 56.2995 196.714 55.9308 196.487 55.7934C196.361 55.717 196.251 55.6994 196.209 55.6837C196.209 55.6837 195.776 55.5527 195.371 55.2334C195.015 54.9523 194.843 54.599 194.695 54.3227C194.038 53.0954 193.761 52.477 193.383 51.5038C192.719 49.7928 192.09 48.6721 192.122 48.6564Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.336 20.1456C187.464 19.6077 188.437 19.4366 188.865 19.2828C190.213 18.7977 191.396 17.8963 192.153 16.6637C192.644 15.8653 192.96 15.0153 193.183 14.1091C193.313 13.5843 193.42 12.8963 193.318 12.3633C193.354 12.5523 193.729 13.917 193.379 15.7774C193.342 15.978 193.222 16.575 192.945 17.3079C192.945 17.3079 192.17 19.7222 189.762 21.8479C189.417 22.1523 189.39 22.1889 188.915 22.5644C188.711 22.7253 188.48 22.8788 188.27 23.0034C188.23 23.0274 188.134 23.1045 188.017 23.0903C187.935 23.0802 187.878 23.0315 187.859 23.0154C187.663 22.8474 187.684 22.6089 187.651 22.1167C187.647 22.0497 187.613 21.62 187.527 21.1615C187.342 20.1883 187.321 20.2096 187.336 20.1456Z",
    fill: "url(#paint12_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.47 59.0548C149.593 58.6404 149.741 58.2335 149.913 57.8368C150.82 55.7342 151.829 54.0543 152.683 52.8064C154.339 50.3842 155.938 48.8129 156.405 48.3629C157.272 47.5286 158.673 46.1972 160.789 44.9402C161.385 44.5861 162.647 43.9637 165.172 42.7187C166.221 42.2014 167.475 41.5932 168.714 40.377C169.246 39.8552 169.596 39.3974 169.683 39.2829C170.803 37.7995 171.134 36.7144 171.169 36.5306C171.185 36.4494 171.025 37.9028 170.252 39.3439C169.778 40.2265 169.289 40.7989 169.18 40.9239C168.886 41.2619 168.463 41.6879 167.025 42.6951C166.641 42.9643 166.104 43.3311 164.825 44.1403C164.026 44.646 163.626 44.8886 161.799 46.0171C160.046 47.0996 159.886 47.203 159.627 47.3811C159.374 47.5548 158.325 48.248 157.13 49.3283C155.25 51.0277 153.936 52.5436 153.142 53.5865C151.953 55.1466 151.121 56.2894 150.189 57.9461C149.576 59.0349 149.122 60.2638 149.141 60.205C149.221 59.9628 149.316 59.5747 149.47 59.0548Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.125 28.7876C171.329 33.9081 168.814 39.4457 164.125 41.7799C160.979 43.346 157.916 44.7355 155.203 47.0375C152.346 49.4626 150.309 52.7397 149.155 56.2886C148.555 58.1317 148.206 60.0425 148.084 61.9762C148.071 62.1817 147.945 65.5292 148.117 65.5333C148.13 65.5337 148.115 64.858 148.235 63.8818C148.294 63.3956 148.435 62.4374 149.05 60.4314C149.386 59.3369 149.653 58.4656 150.097 57.4036C151.004 55.2304 152.037 53.7249 152.752 52.6952C153.516 51.5962 154.862 49.6827 157.136 47.6689C157.646 47.2171 159.485 45.5878 161.548 44.5243C162.395 44.0875 163.443 43.5713 163.443 43.5713C164.634 42.9841 164.865 42.8935 165.537 42.5368C166.493 42.0296 166.971 41.7758 167.526 41.3723C167.963 41.0541 168.75 40.4309 169.533 39.467C170.172 38.6806 170.538 38.0009 170.716 37.6411C171.048 36.9711 171.144 36.5721 171.176 36.4295C171.311 35.8201 171.281 35.3313 171.255 34.9981C171.124 33.2722 170.809 31.7229 170.644 30.92C170.231 28.9156 170.114 28.74 170.125 28.7876Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.084 22.4235C179.075 22.4538 179.075 22.4879 179.074 22.5201C179.07 23.1422 179.047 23.8069 178.813 24.3916C178.683 24.7255 178.49 25.0324 178.269 25.3132C178.227 25.3663 178.184 25.4184 178.14 25.47C177.81 25.8544 177.423 26.1891 177.005 26.4728C176.555 26.7779 176.066 27.0223 175.568 27.2375C175.051 27.4602 174.523 27.5239 173.963 27.5018C173.015 27.4636 172.047 27.2368 171.225 26.7535C171.052 26.6517 170.885 26.5409 170.72 26.4268C170.649 26.3777 170.547 26.2744 170.459 26.2572C170.453 26.2557 170.441 26.2493 170.435 26.2572C170.402 26.3029 170.842 26.7191 171.326 27.0646C172.086 27.607 172.961 27.9831 173.878 28.1628C174.448 28.2747 175.036 28.3312 175.617 28.3058C176.091 28.2852 176.608 28.216 177.016 27.9554C177.102 27.9008 177.182 27.8372 177.251 27.7627C177.318 27.6904 177.464 27.5134 177.731 27.2465C178.045 26.9321 178.189 26.8654 178.515 26.5357C178.748 26.3006 178.851 26.1718 178.969 26.0165C179.274 25.6134 179.396 25.229 179.458 25.0388C179.458 25.0388 179.849 24.0233 179.521 22.9782C179.478 22.8442 179.449 22.7046 179.389 22.577C179.353 22.5014 179.207 22.2491 179.105 22.3816C179.095 22.3939 179.089 22.4081 179.084 22.4235Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.965 19.5835C159.952 19.5535 160.419 19.2032 160.981 19.0632C161.873 18.8416 162.804 19.1975 163.526 19.7133C164.193 20.1891 164.643 20.8891 164.951 21.6373C165.286 22.454 165.36 23.5848 166.089 24.1777C166.27 24.3249 166.455 24.4828 166.667 24.5704C166.739 24.6003 167.228 24.6992 167.293 24.7164C167.32 24.7235 167.003 24.7396 166.762 24.6767C166.376 24.5756 166.125 24.3612 165.977 24.2376C165.69 23.9977 165.529 23.7578 165.408 23.5751C165.229 23.3045 165.128 23.0657 164.932 22.5989C164.729 22.1153 164.747 22.0842 164.574 21.7021C164.415 21.3483 164.316 21.1282 164.123 20.8572C163.88 20.5151 163.632 20.295 163.518 20.2003C163.417 20.1161 163.087 19.8492 162.582 19.6411C162.141 19.4592 161.759 19.4012 161.537 19.3791C161.373 19.363 161.074 19.3353 160.696 19.3937C160.253 19.4622 159.975 19.6059 159.965 19.5835Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.277 24.9157C171.206 24.9461 172.268 24.7656 173.272 23.8224C173.519 23.5907 173.78 23.3522 174.248 22.787C174.853 22.0564 174.864 22.0051 175.285 21.5409C175.856 20.9099 176.281 20.4412 176.99 20.0755C177.773 19.672 178.617 19.517 179.467 19.8225C180.033 20.0261 180.532 20.4143 180.868 20.9132C180.879 20.9297 180.893 20.948 180.913 20.9503C180.938 20.9533 180.958 20.9282 180.97 20.9054C181.05 20.7639 181.097 20.6059 181.124 20.4457C181.155 20.2578 181.159 20.0624 181.105 19.8797C180.983 19.4594 180.584 19.1757 180.174 19.0226C179.507 18.7729 178.761 18.7853 178.07 18.9631C177.044 19.2277 176.007 19.8221 175.252 20.5655C174.854 20.957 174.514 21.4062 174.177 21.8497C173.949 22.1511 173.721 22.4528 173.495 22.756C173.263 23.0663 173.051 23.4121 172.794 23.7011C172.365 24.1858 171.88 24.6552 171.277 24.9157Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.631 29.2524C166.541 29.3157 164.36 32.9031 161.198 34.8589C159.382 35.9825 158.561 36.0918 154.849 37.0239C151.66 37.8245 147.169 37.844 144.607 40.1711C144.147 40.5892 143.534 41.3932 143.489 41.4303C143.42 41.4864 143.785 41.1926 144.074 40.9856C144.899 40.3942 145.575 40.0449 146.307 39.7178C147.388 39.2349 148.342 38.9808 148.995 38.8415C149.377 38.7599 150.557 38.5264 152.037 38.5376C152.465 38.541 152.553 38.5619 153.09 38.5589C154.228 38.5526 155.077 38.4515 155.341 38.4182C155.889 38.3489 156.615 38.2572 157.524 37.9978C158.022 37.856 159.078 37.5198 160.295 36.8218C160.534 36.6844 161.627 36.0473 162.834 34.9068C163.226 34.537 163.927 33.8329 164.649 32.8294C165.264 31.9744 165.804 31.0274 166.023 30.5086C166.067 30.4057 166.197 30.1448 166.368 29.7705C166.55 29.3745 166.664 29.2289 166.631 29.2524Z",
    fill: "#6A3DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.191 13.5993C142.7 13.0913 143.25 12.5972 143.919 12.3333C145.038 11.892 146.415 12.2128 147.224 13.1029C147.891 13.8373 148.152 14.8573 148.234 15.8463C148.34 17.1279 148.301 18.4204 148.393 19.7039C148.414 19.9992 148.436 20.2946 148.46 20.5899C148.678 23.3239 149.62 26.0844 151.398 28.2015C152.626 29.6639 154.48 31.2054 156.484 30.9216C157.248 30.8135 158.028 30.2142 158.549 29.646C158.336 30.4433 157.656 31.0721 156.88 31.3547C156.105 31.6373 155.264 31.6328 154.48 31.3749C153.696 31.1174 152.96 30.6177 152.324 30.0914C151.401 29.3282 150.609 28.4089 149.984 27.3885C149.346 26.3472 148.965 25.2336 148.607 24.0744C148.281 23.0207 147.969 21.9543 147.863 20.8549C147.742 19.5924 147.683 18.3238 147.686 17.0553C147.688 16.4377 147.705 15.8167 147.611 15.2062C147.517 14.5957 147.306 13.9882 146.901 13.5214C146.262 12.7829 145.21 12.4943 144.239 12.6032C143.468 12.6904 142.707 13.0187 142.191 13.5993Z",
    fill: "#6A3DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.629 61.2395C179.112 61.7119 178.85 62.2236 178.721 62.4796C178.673 62.5762 178.461 63.0074 178.321 63.625C178.253 63.9214 178.123 64.5196 178.207 65.2914C178.245 65.6425 178.318 66.262 178.701 66.9388C179.251 67.9097 180.075 68.3567 180.37 68.512C181.046 68.8676 181.631 68.9425 182.099 69.0027C182.574 69.0637 183.612 69.1846 184.828 68.7493C185.22 68.6089 185.867 68.3769 186.478 67.806C186.962 67.3546 187.26 66.8467 187.291 66.7928C187.51 66.411 187.646 66.0782 187.641 66.113C187.622 66.2328 187.587 66.7127 187.379 67.2214C186.959 68.2503 186.149 68.8257 185.863 69.0225C184.391 70.0403 182.736 69.8573 182.246 69.803C181.553 69.7263 179.796 69.5324 178.628 68.0318C177.508 66.5925 177.691 64.9298 177.742 64.459C177.794 63.9843 177.939 62.6675 178.943 61.6969C179.391 61.2638 179.982 60.9382 180.004 60.9258C180.011 60.9228 179.83 61.0561 179.629 61.2395Z",
    fill: "url(#paint13_linear_10069_16055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.74 21.5778C130.739 21.5752 130.739 21.5729 130.738 21.5703C130.932 22.5911 131.344 23.6073 131.745 24.5614C132.158 25.5436 132.649 26.4932 133.21 27.3991C134.319 29.189 135.717 30.8042 137.435 32.0331C139.19 33.2877 141.229 34.1606 143.365 34.4885C144.55 34.6704 145.748 34.6929 146.933 34.5275C148.05 34.3714 149.08 34.1412 150.075 33.5816C150.161 33.5329 150.243 33.4771 150.327 33.4247C149.677 34.1644 148.687 34.4773 147.752 34.663C146.64 34.8838 145.497 34.9467 144.366 34.8718C142.86 34.7723 141.371 34.4286 139.967 33.8743C138.962 33.4775 138.225 33.0605 137.888 32.8618C136.642 32.1259 135.811 31.381 135.523 31.1152C134.729 30.3805 134.21 29.7217 134.002 29.4492C132.662 27.6873 131.78 25.5268 131.183 23.4059C131.013 22.7999 130.857 22.1962 130.74 21.5778Z",
    fill: "#561FDB"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter30_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 238.078,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 247.078,
    cy: 27.625,
    r: 1.00001,
    fill: "#FCFCFD"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter32_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256.078,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter33_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 265.078,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter34_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 274.078,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 283.078,
    cy: 27.625,
    r: 1.00001,
    fill: "#5834A8"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter36_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 292.078,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter37_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 301.078,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter38_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 310.078,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter39_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 319.078,
    cy: 27.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter40_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 247.078,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter41_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256.078,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter42_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 265.078,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter43_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 274.078,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 283.078,
    cy: 41.625,
    r: 1.00001,
    fill: "#372069"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter45_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 292.078,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter46_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 301.078,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter47_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 310.078,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 319.078,
    cy: 41.625,
    r: 1.00001,
    fill: "#FCFCFD"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter49_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328.078,
    cy: 41.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter50_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 238.078,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 247.078,
    cy: 55.625,
    r: 1.00001,
    fill: "#5834A8"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter52_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256.078,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter53_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 265.078,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter54_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 274.078,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter55_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 283.078,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 292.078,
    cy: 55.625,
    r: 1.00001,
    fill: "#6F41D2",
    fillOpacity: 0.25,
    shapeRendering: "crispEdges"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter57_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 301.078,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter58_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 310.078,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter59_d_10069_16055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 319.078,
    cy: 55.625,
    r: 1.00001,
    fill: "#777E90"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10069_16055",
    x: 20.5258,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10069_16055",
    x: 29.5258,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_10069_16055",
    x: 38.5258,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_10069_16055",
    x: 47.5258,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_10069_16055",
    x: 56.5258,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_10069_16055",
    x: 65.5258,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.435294 0 0 0 0 0.968627 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_10069_16055",
    x: 74.5258,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_10069_16055",
    x: 83.5258,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_10069_16055",
    x: 92.5258,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_10069_16055",
    x: 101.526,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_10069_16055",
    x: 11.5258,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_10069_16055",
    x: 20.5258,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_10069_16055",
    x: 29.5258,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_10069_16055",
    x: 38.5258,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_10069_16055",
    x: 47.5258,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.282353 0 0 0 0 0.6 0 0 0 0 0.921569 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_10069_16055",
    x: 56.5258,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_10069_16055",
    x: 65.5258,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_10069_16055",
    x: 74.5258,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_10069_16055",
    x: 83.5258,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.988235 0 0 0 0 0.992157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_10069_16055",
    x: 92.5258,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_10069_16055",
    x: 20.5258,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_10069_16055",
    x: 29.5258,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_10069_16055",
    x: 38.5258,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_10069_16055",
    x: 47.5258,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_10069_16055",
    x: 56.5258,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_10069_16055",
    x: 65.5258,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_10069_16055",
    x: 74.5258,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.701961 0 0 0 0 0.941176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_10069_16055",
    x: 83.5258,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_10069_16055",
    x: 92.5258,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_10069_16055",
    x: 101.526,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_10069_16055",
    x: 234.678,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_10069_16055",
    x: 243.678,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_10069_16055",
    x: 252.678,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_10069_16055",
    x: 261.678,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_d_10069_16055",
    x: 270.678,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_d_10069_16055",
    x: 279.678,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.435294 0 0 0 0 0.968627 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_d_10069_16055",
    x: 288.678,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_d_10069_16055",
    x: 297.678,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_d_10069_16055",
    x: 306.678,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_d_10069_16055",
    x: 315.678,
    y: 24.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_d_10069_16055",
    x: 243.678,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_d_10069_16055",
    x: 252.678,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_d_10069_16055",
    x: 261.678,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_d_10069_16055",
    x: 270.678,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_d_10069_16055",
    x: 279.678,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.282353 0 0 0 0 0.6 0 0 0 0 0.921569 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_d_10069_16055",
    x: 288.678,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_d_10069_16055",
    x: 297.678,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_d_10069_16055",
    x: 306.678,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_d_10069_16055",
    x: 315.678,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.988235 0 0 0 0 0.992157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_d_10069_16055",
    x: 324.678,
    y: 38.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_d_10069_16055",
    x: 234.678,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_d_10069_16055",
    x: 243.678,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_d_10069_16055",
    x: 252.678,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_d_10069_16055",
    x: 261.678,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_d_10069_16055",
    x: 270.678,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_d_10069_16055",
    x: 279.678,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_d_10069_16055",
    x: 288.678,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.701961 0 0 0 0 0.941176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_d_10069_16055",
    x: 297.678,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_d_10069_16055",
    x: 306.678,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_d_10069_16055",
    x: 315.678,
    y: 52.225,
    width: 6.80004,
    height: 6.80004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.00001,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.700005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10069_16055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10069_16055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10069_16055",
    x1: 142.262,
    y1: 84.5174,
    x2: 218.82,
    y2: -43.1978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    stopColor: "#8618FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#851CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3984,
    stopColor: "#8228F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#7D3CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#7658F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5222,
    stopColor: "#6D7CEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5628,
    stopColor: "#62A7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#5BC5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10069_16055",
    x1: 128.055,
    y1: 43.4217,
    x2: 189.358,
    y2: 43.4217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67B3F2",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1486,
    stopColor: "#67B0F2",
    stopOpacity: 0.9212
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2669,
    stopColor: "#66A6F2",
    stopOpacity: 0.9381
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#6495F2",
    stopOpacity: 0.9534
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4764,
    stopColor: "#627DF3",
    stopOpacity: 0.9679
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5737,
    stopColor: "#605FF3",
    stopOpacity: 0.9818
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6665,
    stopColor: "#5C3AF4",
    stopOpacity: 0.9951
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7011,
    stopColor: "#5B2AF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10069_16055",
    x1: 138.825,
    y1: 20.6988,
    x2: 157.525,
    y2: 20.6988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C45F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6793,
    stopColor: "#67B3F2",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10069_16055",
    x1: 130.399,
    y1: 23.0645,
    x2: 150.895,
    y2: 23.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6C45F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7729,
    stopColor: "#67B3F2",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10069_16055",
    x1: 177.031,
    y1: 54.8974,
    x2: 193.941,
    y2: 54.8974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67B3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4566,
    stopColor: "#6A6CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7003,
    stopColor: "#6C45F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10069_16055",
    x1: 190.386,
    y1: 50.991,
    x2: 215.809,
    y2: 50.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67B3F2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#67B0F2",
    stopOpacity: 0.616
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#68A6F2",
    stopOpacity: 0.7083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3327,
    stopColor: "#6895F2",
    stopOpacity: 0.7925
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#697DF2",
    stopOpacity: 0.8718
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5085,
    stopColor: "#6B5FF3",
    stopOpacity: 0.947
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5688,
    stopColor: "#6C45F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10069_16055",
    x1: 177.735,
    y1: 34.4809,
    x2: 216.474,
    y2: 34.4809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#67B3F2",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2591,
    stopColor: "#67B0F2",
    stopOpacity: 0.3088
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3673,
    stopColor: "#68A6F2",
    stopOpacity: 0.4749
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#6895F2",
    stopOpacity: 0.6265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5589,
    stopColor: "#697DF2",
    stopOpacity: 0.7692
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6471,
    stopColor: "#6B5FF3",
    stopOpacity: 0.9046
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#6C45F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10069_16055",
    x1: 156.563,
    y1: 21.6047,
    x2: 140.531,
    y2: 12.3489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6788,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10069_16055",
    x1: 131.434,
    y1: 23.8363,
    x2: 145.992,
    y2: 23.8363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5164,
    stopColor: "white",
    stopOpacity: 0.954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5688,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10069_16055",
    x1: 181.473,
    y1: 28.8619,
    x2: 204.422,
    y2: 28.8619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6366,
    stopColor: "white",
    stopOpacity: 0.5368
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7011,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10069_16055",
    x1: 187.844,
    y1: 57.1765,
    x2: 193.979,
    y2: 57.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "white",
    stopOpacity: 0.6928
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10069_16055",
    x1: 184.984,
    y1: 37.1626,
    x2: 215.103,
    y2: 37.1626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A32BD",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5551,
    stopColor: "#5A37BE",
    stopOpacity: 0.5547
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6788,
    stopColor: "#5A39BF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10069_16055",
    x1: 188.959,
    y1: 16.0805,
    x2: 193.366,
    y2: 20.4341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A32BD",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5551,
    stopColor: "#5A37BE",
    stopOpacity: 0.5547
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6788,
    stopColor: "#5A39BF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10069_16055",
    x1: 177.699,
    y1: 65.3894,
    x2: 187.641,
    y2: 65.3894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67B3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4566,
    stopColor: "#6A6CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7003,
    stopColor: "#6C45F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10069_16055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.1529,
    height: 83.2491,
    fill: "white",
    transform: "translate(121.926)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLogoMobile);
export default __webpack_public_path__ + "static/media/authLogoMobile.def31d32a4200ebb45963778546564e3.svg";
export { ForwardRef as ReactComponent };